import { render } from "./KycView.vue?vue&type=template&id=5bf4000e"
import script from "./KycView.vue?vue&type=script&lang=js"
export * from "./KycView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__